// src/tattoo/bodyContext.js
import { tattoo } from "./state";

export function buildBodyContext() {
  return {
    v: 1,
    ts: Date.now(),
    sex: tattoo.sex || null,
    morphs: tattoo.morphs || {},     // ✅ plural
    skinColor: tattoo.skinColor ?? null,
  };
}